/**
 * Inventory calculation utilities for the Product Inventory (GSP Tracker) page.
 * Used to compute derived values from TInvent inventory data.
 */

/**
 * Calculate safety stock, scaled by lead time.
 */
export function calculateSafetyStock(lastMonthlyOrders: number, leadTimeDays: number): number {
    return Math.ceil((lastMonthlyOrders * 12 / 52) * (leadTimeDays / 7));
}

/**
 * Calculate restock threshold (reorder point).
 * Formula: ((lastMonthlyOrders / 30) * leadTimeDays) + safetyStock
 * = daily average demand × lead time + safety buffer
 */
export function calculateRestockThreshold(lastMonthlyOrders: number, leadTimeDays: number): number {
    const safetyStock = calculateSafetyStock(lastMonthlyOrders, leadTimeDays);
    const dailyDemand = lastMonthlyOrders / 30;
    return Math.ceil((dailyDemand * leadTimeDays) + safetyStock);
}

/**
 * Calculate total seats.
 * Formula: seatsAvailable + pendingDelivery (seats on hand plus seats already on order).
 * `pendingDelivery` is optional on ProductInventoryItem; treated as 0 when absent.
 */
export function calculateTotalSeats(seatsAvailable: number, pendingDelivery?: number): number {
    return seatsAvailable + (pendingDelivery ?? 0);
}
